import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  users: [],
};

const getters = {
  getUsers: (state) => state.users,
};

const actions = {
  async for_outfitter({ commit }, id) {
    const resp = await asyncHandler(
      HTTP({ url: "user/for-outfitter/" + id, method: "GET" })
    );
    if (resp.success) {
      commit("set_users", resp.users);
    }
    return resp;
  },

  async all({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "user/all/" + data.withDeleted, method: "GET" })
    );
    if (resp.success) {
      commit("set_users", resp.users);
    }
    return resp;
  },

  async reload({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "user/all/" + data.withDeleted, method: "GET" })
    );
    if (resp.success) {
      commit("set_users", resp.users);
    }
    return resp;
  },

  async save_user(context, data) {
    const url = data.id ? "user/" + data.id : "user";
    const method = data.id ? "PUT" : "POST";
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async delete_user(context, data) {
    return await asyncHandler(
      HTTP({ url: "user/" + data.id, method: "DELETE" })
    );
  },

  async restore_user(context, data) {
    return await asyncHandler(
      HTTP({ url: "user/restore/" + data.id, method: "GET" })
    );
  },
};

const mutations = {
  set_users: (state, users) => {
    state.users = users;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
